import { tosConfig } from '@/config'
import envCfg from '@/config/env'

// 处理需要拼接TOS直连地址的URL
const processTosUrl = (url) => {
  if (!url) return url
  // 如果包含avatar、cover、modelCover、materialCover，且不是完整URL，则拼接TOS前缀
  if ((url.includes('avatar') || url.includes('cover') || url.includes('modelCover') || url.includes('materialCover')) &&
      !url.startsWith('http://') && !url.startsWith('https://')) {
    return `${tosConfig.baseUrl}${url}`
  }
  return url
}

// 获取API基础URL
const getApiBaseUrl = () => {
  return envCfg[process.env.REACT_APP_ENV]['API_BASE_URL']
}

export const downloadFile = async (url, callback) => {
  if (!url) {
    return ''
  }

  // Mock模式下，跳过下载
  if (process.env.REACT_APP_USE_MOCK === 'true') {
    console.log('[OSS] Mock模式，跳过下载，直接返回URL:', url)
    return url
  }

  // 处理需要拼接TOS地址的URL（如avatar、cover、modelCover、materialCover）
  const processedUrl = processTosUrl(url)
  if (processedUrl !== url) {
    console.log('[OSS] 检测到TOS路径，拼接后返回:', processedUrl)
    return processedUrl
  }

  // 支持的模型文件格式
  const modelExtensions = ['.glb', '.gltf', '.fbx', '.obj', '.stl', '.ply', '.dae', '.3ds', '.usdz', '.zip', '.hdr']
  const decodedUrl = decodeURIComponent(url)
  const lowerUrl = decodedUrl.toLowerCase()
  const isModelFile = modelExtensions.some(ext => lowerUrl.endsWith(ext))

  // 如果不是模型文件，直接返回原URL
  if (!isModelFile) {
    return url
  }

  // 模型文件通过服务器接口直接返回流式下载URL
  // 判断是编码路径还是完整URL
  const isEncodedPath = !url.startsWith('http://') && !url.startsWith('https://')

  let key
  if (isEncodedPath) {
    // 编码路径格式，先解码后重新编码（确保编码正确）
    key = decodeURIComponent(url)
  } else {
    // 完整URL格式，从URL中提取pathname
    key = new URL(url).pathname.slice(1)
  }

  // 直接构建后端流式下载URL（后端返回文件流，不是JSON）
  const downloadUrl = `${getApiBaseUrl()}/oss/getModel?key=${encodeURIComponent(key)}`
  console.log('[OSS] 构建模型下载地址:', downloadUrl)
  return downloadUrl
}
